export default {
  name: 'AppHeader',
  data() {
    return {
      titleText: '銀保服務站'
    }
  },
  methods:{
    lastPageHandler: function () {
      let vm = this;
      vm.$router.push({ name: 'index' });
    }
  },
}